import { WorkOrderTaskType } from '@xbcb/work-order-types';

export const ASSIGNMENT_QUEUE = 'Assignment Queue';
export const NRBS_RECORD_NUMBER_LEN = 10;
export const WOT_TYPES_WITH_COMMODITY_GROUPS = [
  WorkOrderTaskType.US_CONSUMPTION_ENTRY_BUILD_INVOICE,
  WorkOrderTaskType.US_CONSUMPTION_ENTRY_COMPLETION_SUBMISSION,
  WorkOrderTaskType.US_CONSUMPTION_ENTRY_CONSOLIDATION_COMPLETION,
  WorkOrderTaskType.US_CONSUMPTION_ENTRY_SPLIT_COMPLETION_SUBMISSION,
];
